'use strict';
import isObject from 'lodash/isObject';
import React from 'react';
import * as T from 'prop-types';
import classNames from 'classnames';
import {ListItem} from '../../../components/lists/ListItem';
import {getCollection, getId} from '../../../core-utilities/domain/ReduxUtils';
import {StatelessStatusSelector} from '../../../core-components/selectors/components/StatelessStatusSelector';
import {stopPropagation} from '../../../core-utilities/react-utils';
import {CommentIndicatorComponent} from '../../../comments/components/CommentIndicator/CommentIndicatorComponent';


export function AssetProjectItemView(props) {
  const model = props.model;

  return (
    <ListItem
      className={classNames("AssetProjectItem", props.className)}
      title={model.shortName}
      bindParam={model}
      onClick={props.onClick}
      onContextMenu={props.onContextMenu}
    >
      <div className="card">
        <div className="AssetProjectItem__body">
          <div
            className="AssetProjectItem__statusSelector"
            onClick={stopPropagation}
          >
            <StatelessStatusSelector
              className=""
              labelClassName=""
              model={model}
              hideValue={true}

              status={model.status}
              collection={model.collection}
              validStatuses={model.validStatuses}
            />
          </div>

          <div className="AssetProjectItem__nameArea">
            <span>
              {model.shortName}
            </span>
            <div className="task-card-description">
              <span title={model.identifier}>
                {model.identifier}
              </span>
            </div>
          </div>

          <i className="AssetProjectItem__navIcon icon ion-chevron-right" />
        </div>

        <div className="AssetProjectItem__stats">
          <div className="AssetProjectItem__metrics">
            <div className="AssetProjectItem__metrics__container">
              <i className="icon ion-ios-folder-outline" />
              <span className="AssetProjectItem__metrics__label">
                {getFileRequirementMetrics(model.metrics)}
              </span>
            </div>

          </div>
          <div className="AssetProjectItem__buttons">
            <div className="AssetProjectItem__buttons_comment">
              <CommentIndicatorComponent
                init={props.init}
                userId={props.userId}
                chatId={getId(props.model)}
                collection={getCollection(props.model)}
                allowNav={false}
                className="icon"
              />
            </div>
          </div>
        </div>
      </div>
    </ListItem>
  );
}

AssetProjectItemView.commentIndicatorClassName = 'icon';

AssetProjectItemView.propTypes = {
  className: T.string,
  model: T.shape({
    shortName: T.string.isRequired,
    identifier: T.string,
    metrics: T.object,
  }),

  onClick: T.func,
  onContextMenu: T.func,

  init: T.bool,
};

AssetProjectItemView.defaultProps = {
  init: true,
};

export function getFileRequirementMetrics(metrics) {
  if (!isObject(metrics)) {
    return '-';
  } else {
    const total = metrics.reqCount - metrics.reqCancelled;
    const current = metrics.reqSubmitted + metrics.reqApproved;

    return !total ? '-' : `${current}/${total}`;
  }
}



// WEBPACK FOOTER //
// ./src/js/projects/components/AssetProjectItem/AssetProjectItemView.js